import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import useSaleCompsWithFocusArea from "../../hooks/useSaleCompsWithFocusArea";
import useSaleCompsWithGlobalFilters from "../../hooks/useSaleCompsWithGlobalFilters";
import { useSaleCompStore } from "../../index";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import SaleCompsGrid from "../saleComps/SaleCompsGrid";

function CompanyDetailsSaleCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const saleCompStore = useSaleCompStore();
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(
        useMemo(() => computed(() => saleCompStore.saleComps.filter(sc => sc.pipedriveBrokerageId?.toString() === id || sc.pipedriveSellerId?.toString() === id || sc.pipedriveBuyerId?.toString() === id)), [id]).get()
    ));

    useEffect(() => setEntityCount(saleComps.length), [saleComps]);

    if (!visible)
        return null;

    return (
        <SaleCompsGrid saleComps={saleComps} />
    );
}

export default observer(CompanyDetailsSaleCompsTab);